<template>
  <div class="progress-bar-illustration">
    <div class="progress cashflow-type-background-color" :style="progressBarStyle"></div>
  </div>
</template>

<script>
import _ from 'lodash';
import TWEEN from 'tween';
import moneyUtils from '../utils/money';

export default {
  name: 'AnimatedBar',
  props: {
    totalAmount: {
      required: true,
    },
    upToNowAmount: {
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      tweeningTotalAmountValue: 0,
    };
  },
  watch: {
    totalAmount(newValue, oldValue) {
      this.tween(oldValue, newValue);
    },
  },
  mounted() {
    this.tween(this.totalAmount, this.totalAmount);
  },
  computed: {
    formattedTweeningValue() {
      return moneyUtils.formatAmountWithFraction(this.tweeningTotalAmountValue, 0);
    },
    progressBarStyle() {
      const widthPct = this.disabled ? 0 :
        _.min([Math.ceil((this.upToNowAmount / this.tweeningTotalAmountValue) * 100), 100]);
      return {
        width: `${widthPct}%`,
      };
    },
  },
  methods: {
    tween(startValue, endValue) {
      const vm = this;
      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }

      new TWEEN.Tween({ tweeningTotalAmountValue: startValue })
        .to({ tweeningTotalAmountValue: endValue }, 1000)
        .onUpdate(function () { // eslint-disable-line
          vm.tweeningTotalAmountValue = this.tweeningTotalAmountValue.toFixed(0);
        })
        .start();

      animate();
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../../node_modules/base-ui/src/scss/riseup-colors';

  .progress-bar-illustration {
    height: 15px;
    width: 100%;
    background-color: $riseup_gray_0;

    .progress {
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/AnimatedBar.vue